import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { studentParentsCrudStateConfig } from "../../../consts";

export type { CrudBuilderState as StudentParentsMeta };
export const studentParentsMetaState = makeCrudBuilderInitialState(
  studentParentsCrudStateConfig
);
